import { render } from "./media-carousel.vue?vue&type=template&id=058f482c"
import script from "./media-carousel.vue?vue&type=script&lang=js"
export * from "./media-carousel.vue?vue&type=script&lang=js"

import "./media-carousel.vue?vue&type=style&index=0&id=058f482c&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__